import {Component, EventEmitter, Inject, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {STEPPER_GLOBAL_OPTIONS} from "@angular/cdk/stepper";
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup} from "@angular/forms";
import {CustomerDataService} from "../customer.data.service";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {ToasterService} from "../../../services/core/toaster.service";
import {SharedDataService} from "../../shared/shared.data.service";
import { first, finalize } from "rxjs/operators";
import {SharedService} from "../../shared/shared.service";
import {DialogService} from "../../../services/core/dialog.service";
import {Router} from "@angular/router";
import {BackendApiService} from "../../../services/backend-api.service";
import {
  CustomerComponentsCommunicationServiceService
} from "../service/customer-components-communication-service.service";
import {MatStepper} from "@angular/material/stepper";
import {ModuleDataMilestoneService} from "../../../services/module-data-milestone.service";

@Component({
    selector: 'app-customer-create-edit',
    templateUrl: './customer-create-edit.component.html',
    styleUrls: ['./customer-create-edit.component.scss'],
    providers: [
        {
            provide: STEPPER_GLOBAL_OPTIONS,
            useValue: { showError: true },
        },
    ],
    standalone: false
})
export class CustomerCreateEditComponent implements OnInit, OnChanges {

  @Output() onAdd = new EventEmitter<any>(true);
  public submitted = false;
  public model:any = null;
  public isEdit= false;
  public isSaving = false;
  public customerForm!: UntypedFormGroup;
  public step:any;
  public id: string = '';
  currentTab: string = 'Contact Details';
  public company_name: any;

  /** Module id of the Customer module — used for milestone auto-deploy. */
  private readonly CUSTOMER_MODULE_ID = 13;

  constructor(

    private _formBuilder: UntypedFormBuilder,
    public fb: UntypedFormBuilder,
    public customerDataService: CustomerDataService,
    private router: Router,
    public toasterService: ToasterService,
    public sharedDataService: SharedDataService,
    public sharedService: SharedService,
    public dialogService: DialogService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public backendApiService: BackendApiService,
    public customerComponentCommunicationService: CustomerComponentsCommunicationServiceService,
    private moduleDataMilestoneService: ModuleDataMilestoneService
  ) {
    this.model = this.data;
    this.id = this.data?.model?.id;
    this.isEdit = this.data?.isEdit;
  }
  goBack(stepper: MatStepper) {
      stepper.previous();
  }

  ngOnChanges(changes: SimpleChanges) {
  }

  ngOnInit() {
    // Clear previous business data when dialog opens
    sessionStorage.removeItem('selectedBusinessProfile');

    this.customerForm = new UntypedFormGroup({
      step01: new UntypedFormGroup({
        company: new UntypedFormControl(null)
      }),
      step02: new UntypedFormGroup({
        detail: new UntypedFormControl(null)
      }),
      step03: new UntypedFormGroup({
        contact: new UntypedFormControl(null)
      }),
      step04: new UntypedFormGroup({
        adminInformation: new UntypedFormControl(null)
      }),
      step05: new UntypedFormGroup({
        preview: new UntypedFormControl(null)
      }),
    });
  }

  handleInput(event: KeyboardEvent): void{
    event.stopPropagation();
  }
  onStepChanged = (event:any, stepper:any) => {
    this.step = {event:event, stepper:stepper};
    if(event.previouslySelectedIndex == 0 &&  event.selectedIndex == 1){
     this.company_name = this.customerForm.get('step01')?.value?.company?.name;
    }
  }
  touchFormControls(formControlName: string, secondFormControlName: any = null){
    let customerForm = this.customerForm.get(formControlName);
    // @ts-ignore
    customerForm = secondFormControlName ? customerForm?.get(secondFormControlName) : customerForm;
    customerForm?.markAsTouched()
    customerForm?.updateValueAndValidity({ onlySelf: false, emitEvent: true });
  }
  onSubmit() {
    if (this.customerForm.invalid || this.isSaving) {
      return;
    }


    const isCreate = !this.id;
    const  customerDataService = this.id ?
      this.customerDataService.update(this.id , this.getFormData()) :
      this.customerDataService.create(this.getFormData());

    this.isSaving = true;
    customerDataService
      .pipe(
        first(),
        finalize(() => {
          this.isSaving = false;
        })
      )
      .subscribe({
        next: data => {

          if (isCreate) {
            const newCustomerId = data?.data?.customer?.id;
            if (newCustomerId) {
              this.autoDeployMilestones(newCustomerId);
            }
          }

          if(this.customerForm?.value?.step02?.detail?.is_jobsite && !this.id) {
            // saves the jobsite
            this.saveJobsite(data);
          }else {

            this.toasterService.showSuccessMessage(data?.data?.message);
            this.close(data?.data?.customer);
          }
        },
        error: error => {
          const message = error?.error?.message || 'Unable to save customer. Please try again.';
          this.toasterService.showErrorMessage(message);
        }
      });
  }

  changedHandler = (event:any) => {

  }

  /**
   * After a customer is created, attach the Customer module's auto-deploy milestone
   * template (if one is enabled). Fire-and-forget — failures are logged silently and
   * never block the create flow.
   */
  private autoDeployMilestones(customerId: number) {
    this.moduleDataMilestoneService
      .autoDeploy(this.CUSTOMER_MODULE_ID, customerId)
      .pipe(first())
      .subscribe({
        next: () => {},
        error: (err) => {
          console.error('Milestone auto-deploy failed for customer', customerId, err);
        }
      });
  }

  close = (customer:any = null) => {
    this.dialogService.onClose(customer);
  }

  getFormData = () => {
    console.log('model customer',this.model);
    return {
      company_name: this.customerForm?.value?.step01?.company?.name,

      // step 02 form data
      company_title: this.customerForm?.value?.step02?.detail?.company_title,
      company_email: this.customerForm?.value?.step02?.detail?.company_email,
      is_jobsite: this.customerForm?.value?.step02?.detail?.is_jobsite,
      phone: this.customerForm?.value?.step02?.detail?.phone,
      extension: this.customerForm?.value?.step02?.detail?.extension,
      secondary_phone: this.customerForm?.value?.step02?.detail?.secondary_phone,
      fax: this.customerForm?.value?.step02?.detail?.fax,
      website: this.customerForm?.value?.step02?.detail?.website,
      group_id: this.customerForm?.value?.step02?.detail?.group?.id,
      state_id: this.customerForm?.value?.step02?.detail?.main_address?.state_id?.id,
      address_line_1: this.customerForm?.value?.step02?.detail?.main_address?.address_line_1,
      address_line_2: this.customerForm?.value?.step02?.detail?.main_address?.address_line_2,
      city: this.customerForm?.value?.step02?.detail?.main_address?.city,
      zipcode: this.customerForm?.value?.step02?.detail?.main_address?.zipcode,
      billing_state_id: this.customerForm?.value?.step02?.detail?.billing_address?.state_id?.id,
      billing_address_line_1: this.customerForm?.value?.step02?.detail?.billing_address?.address_line_1,
      billing_address_line_2: this.customerForm?.value?.step02?.detail?.billing_address?.address_line_2,
      billing_city: this.customerForm?.value?.step02?.detail?.billing_address?.city,
      billing_zipcode: this.customerForm?.value?.step02?.detail?.billing_address?.zipcode,
      shipping_state_id: this.customerForm?.value?.step02?.detail?.shipping_address?.state_id?.id,
      shipping_address_line_1: this.customerForm?.value?.step02?.detail?.shipping_address?.address_line_1,
      shipping_address_line_2: this.customerForm?.value?.step02?.detail?.shipping_address?.address_line_2,
      shipping_city: this.customerForm?.value?.step02?.detail?.shipping_address?.city,
      shipping_zipcode: this.customerForm?.value?.step02?.detail?.shipping_address?.zipcode,

      // Logo and business hours
      start_time: this.customerForm?.value?.step02?.detail?.start_time,
      end_time: this.customerForm?.value?.step02?.detail?.end_time,
      logo_attachment_id: this.customerForm?.value?.step02?.detail?.logo_file, // From user upload
      clearbit_logo_url: this.getClearbitLogoUrl(), // From Google Places

      // step 03 form data
      first_name: this.customerForm?.value?.step03?.contact?.first_name,
      last_name: this.customerForm?.value?.step03?.contact?.last_name,
      email: this.customerForm?.value?.step03?.contact?.email,
      contact_phone: this.customerForm?.value?.step03?.contact?.phone,
      mobile: this.customerForm?.value?.step03?.contact?.mobile,
      contact_authority: this.customerForm?.value?.step03?.contact?.contact_authority_id ?? null,
      username: this.customerForm?.value?.step03?.contact?.username,
      password: this.customerForm?.value?.step03?.contact?.password,
      notes: this.customerForm?.value?.step03?.contact?.notes,
      has_portal_access: this.customerForm?.value?.step03?.contact?.has_portal_access,
      is_primary: this.customerForm?.value?.step03?.contact?.is_primary,

      // step 04 form data
      sales_rep_id: this.customerForm?.value?.step04?.adminInformation?.sales_rep_id?.id,
      tax_exempt: this.customerForm?.value?.step04?.adminInformation?.tax_exempt,
      default_payment_method: this.customerForm?.value?.step04?.adminInformation?.payment_method?.id,
      term_id: this.customerForm?.value?.step04?.adminInformation?.term_id?.id,
      preferred_markup: this.customerForm?.value?.step04?.adminInformation?.markup,
      lien_period: this.customerForm?.value?.step04?.adminInformation?.lien_period,
      source_id: this.customerForm?.value?.step04?.adminInformation?.source?.id,
      risk: this.customerForm?.value?.step04?.adminInformation?.risk,


      status:this.model?.model?.status?.id ?? 1,
      type:0,
    }
  }

  getJobSiteData = () => {
    return {
      title: this.customerForm?.value?.step02?.detail?.company_title,
      email: this.customerForm?.value?.step02?.detail?.company_email,
      phone: this.customerForm?.value?.step02?.detail?.phone,
      fax: null,
      address: this.customerForm?.value?.step02?.detail?.main_address?.address_line_1,
      address2: this.customerForm?.value?.step02?.detail?.main_address?.address_line_2,
      city: this.customerForm?.value?.step02?.detail?.main_address?.city,
      state_id: this.customerForm?.value?.step02?.detail?.main_address?.state_id?.id,
      zipcode: this.customerForm?.value?.step02?.detail?.main_address?.zipcode,
      country_id: 231,
    }
  }

  saveJobsite(data: any) {
    this.isSaving = true;
    this.backendApiService.postApi('jobsites/create',this.getJobSiteData())
      .pipe(finalize(() => {
        this.isSaving = false;
      }))
      .subscribe((response: any) => {
        console.log('response',response);

        // success message for new customer created
        this.toasterService.showSuccessMessage(data?.data?.message);
        let customer = data?.data?.customer;
        customer['jobsite'] = response?.data?.data;
        this.customerComponentCommunicationService.setCustomerJobSiteValue(customer);
        this.close(customer);
      },
      error => {
        const message = error?.error?.message || 'Unable to save jobsite. Please try again.';
        this.toasterService.showErrorMessage(message);
      })
  }

  initChildForm(step: string, formControlName: string, value:any){
    this.customerForm.get(step)?.get(formControlName)?.setValue(value);

  }

  getClearbitLogoUrl = () => {
    const logoAttachmentId = this.customerForm?.value?.step02?.detail?.logo_file;
    const originalLogoAttachmentId = this.model?.model?.logo_attachment_id;

    // Check if there's a NEW user upload (different from original)
    if (logoAttachmentId && logoAttachmentId !== originalLogoAttachmentId) {
      return null; // User uploaded a new logo
    }

    // Get Clearbit logo URL from sessionStorage (for new company selection)
    const businessDataStr = sessionStorage.getItem('selectedBusinessProfile');
    if (businessDataStr) {
      const businessData = JSON.parse(businessDataStr);
      if (businessData.domain) {
        return `https://logos-api.apistemic.com/domain:${businessData.domain}`;
      }
    }
    return null;
  }
}
